import { useNavigator } from '@repo/toolkit/use-navigator'
import { Column } from '@repo/ui/data-table'
import { PlusIcon, ProviderIcon } from '@repo/ui/icons'

import { API } from '../../api/apis.config'
import DynamicDataTable from '../../components/elements/dynamic-table'
import UserNavBar from '../../components/elements/nav-bar'
import { Paths } from '../../lib/constants/path'
import { TripProviderTypes } from '../../lib/types/models/trip-provider/trip-provider'

const TripProviderListPage = () => {
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<TripProviderTypes.Full>[] = [
    {
      accessorKey: 'companyName',
      header: 'NOM de la société',
      enableSorting: true
    },
    {
      accessorKey: 'comments',
      header: 'Commentaire',
      enableSorting: true,
      cell: ({ row }) => {
        return <div className="text-wrap w-3/4 py-3">{row.original.comments}</div>
      }
    }
  ]

  return (
    <div>
      <UserNavBar title={'Prestataires voyages'} icon={ProviderIcon} />
      <div className={'h-4'} />

      <DynamicDataTable<TripProviderTypes.Full, null>
        title={'Tous les prestataires voyages'}
        deleteMessage={{ name: 'prestataire de voyage', attributeName: 'companyName' }}
        columns={columns}
        selectable
        allowSearchParam
        endpoint={API.tripProviders.getAll.url}
        onRowClick={(tripProvider, event) =>
          navigateWithEvent(
            Paths.TRIP_PROVIDER_UPDATE_PAGE.replace(':id', tripProvider.id.toString()),
            event
          )
        }
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            refetch: true,
            variant: 'primary',
            label: 'Ajouter un nouveau prestataire de voyage',
            fn: () => navigate(Paths.TRIP_PROVIDER_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default TripProviderListPage
